import React from 'react';
import { css as reactCss } from '@emotion/react';

import { colors } from '~src/main/theme/colors';

export const Separator: React.FC<React.HTMLAttributes<HTMLElement>> = ({ children, ...props }) => {
  return (
    <div css={styles.wrapper} {...props}>
      {children}
    </div>
  );
};

const styles = {
  wrapper: reactCss({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    color: colors.neutral45,
    fontSize: '12px',
    lineHeight: '16px',
    '& > *:before': {
      content: '"·"',
      margin: '0 6px',
      color: colors.neutral45,
    },
    '& > *:first-child:before': {
      content: 'none',
    },
  }),
};
